import { Component } from '@angular/core';
import { NavController, NavParams, Events, ViewController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { TimeoutProvider } from '../../providers/timeout/timeout';

/**
 * Generated class for the CoNovelistModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-novelist-modal',
  templateUrl: 'co-novelist-modal.html',
})
export class CoNovelistModalPage {
  ifRecommended: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public state: AppState, public events : Events, public viewCtrl : ViewController, public timeout: TimeoutFunctionsProvider, public timeoutProvider : TimeoutProvider) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
  }

  ionViewDidLoad() {
    // setTimeout(function(){
    //   this.dismiss();
    // }, 10000);
    // this.events.publish('changeTimeoutTiming', true);
    this.timeoutProvider.changeTimeout(this.state.novelistTimeoutNumber,true,0);
  }

  dismiss(){
    // this.state.novelistArray = [];
    this.viewCtrl.dismiss().catch(err=>{});
  }
  novelistLoaded(state){
    this.ifRecommended=true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-novelist-modal/co-novelist-modal.ts